
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's182ab2d6c997515f': `បន្ថែមវាទៅកាន់ផ្ទាំងអេក្រង់ដើមដើម្បីទទួលបាននូវបទពិសោធន៍កាន់តែល្អនិងងាយស្រួលប្រើ។`,
's224cbcec014ef6b5': `ចុចលើ ប៊ូតុងចែករំលែក នៅក្នុងរបារទិសដៅ`,
's37a9e8aec5713460': `បង្ហាញបន្ថែម`,
's386eca8362ff6155': `ចុចលើ បន្ថែម ប្រសិនបើគ្មានរូបសញ្ញា ចែករំលែក`,
's4e1e10a6ca408245': `ចុចលើ "បន្ថែមទៅកាន់ផ្ទាំងអេក្រង់ដើម"`,
's6196153c4b0c1ea0': `តំឡើង`,
's633502f7cff4f847': `បើកម៉ឺនុយកម្មវិធីរុករករបស់អ្នក`,
's681e399d63311fba': `បង្ហាញវិចិត្រសាល`,
's7f0591f08e318eda': `ចុចលើ បន្ថែម នៅក្នុងម៉ឺនុយ ចែករំលែក`,
's8114bd55cae5a22b': `ចុចលើ បន្ថែមទៅកាន់ Dock`,
's922329d6f6213590': `បន្ថែមទៅកាន់ Dock`,
's9af56bf005b49c74': `អូសចុះទៅកាន់ "បន្ថែមទៅផ្ទាំងអេក្រង់ដើម"`,
'sa5ef80b4bb9b39f8': `បង្ហាញតិច`,
'sba52286c21552a4e': `តំឡើងវានៅលើឧបករណ៍របស់អ្នកដើម្បីទទួលបាននូវបទពិសោធន៍កាន់តែល្អនិងងាយស្រួលប្រើ។`,
'sc16e00a7a8b2fde2': `ត្រឡប់ក្រោយ`,
'scdaf4bbff76674c8': `បន្ថែមទៅកាន់ផ្ទាំងអេក្រង់ដើម`,
'se0e473adfda8066c': `បើកនៅក្នុងកម្មវិធីរុករកសំខាន់របស់អ្នក`,
'se740f75b95a51807': `បន្ថែមវាទៅកាន់ Dock ដើម្បីទទួលបាននូវបទពិសោធន៍កាន់តែល្អនិងងាយស្រួលប្រើ។`,
'sfea652f6580ff086': `គេហទំព័រនេះមានមុខងារជាកម្មវិធី។`,
    };
  